<script lang="ts">
export interface ExpansionPanelProps extends CollapsibleRootProps, ClassProps {
	label?: string;
}

export type ExpansionPanelEmit = CollapsibleRootEmits;
</script>

<script setup lang="ts">
import { mdiChevronDown } from "@mdi/js";
import {
	CollapsibleContent,
	CollapsibleRoot,
	CollapsibleTrigger,
	useForwardPropsEmits,
	type CollapsibleRootEmits,
	type CollapsibleRootProps,
} from "reka-ui";
import { useDelegatedProps, type ClassProps } from "../../lib/base-props";
import Icon from "../icon/Icon.vue";

const props = defineProps<ExpansionPanelProps>();
const emits = defineEmits<ExpansionPanelEmit>();

defineSlots<{
	trigger(): void;

	/** @deprecated */
	activator(): void;
}>();

const delegatedProps = useDelegatedProps(props);
const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
	<CollapsibleRoot v-slot="{ open }" :class="props.class" v-bind="forwarded">
		<CollapsibleTrigger class="w-full">
			<slot name="trigger">
				<slot name="activator">
					<div class="flex w-full items-center justify-between">
						<h3>{{ label }}</h3>
						{{ open }}
						<Icon
							:class="{
								'size-5 transition duration-200': true,
								'rotate-180 transform': !open,
							}"
							:d="mdiChevronDown"
						/>
					</div>
				</slot>
			</slot>
		</CollapsibleTrigger>

		<CollapsibleContent class="expansion-panel-content">
			<slot />
		</CollapsibleContent>
	</CollapsibleRoot>
</template>
